import { FaCheck, FaTimes } from "react-icons/fa";
import "./legal-content.css";

export function LegalDocument({ children }) {
  return <div className="legal-document">{children}</div>;
}

export function LegalSection({ title, children, id }) {
  return (
    <section className="legal-section" id={id}>
      <h2 className="legal-section__title">{title}</h2>
      {children}
    </section>
  );
}

export function LegalLead({ children }) {
  return <p className="legal-section__lead">{children}</p>;
}

export function LegalText({ children }) {
  return <p className="legal-section__text">{children}</p>;
}

export function LegalIntroBanner({ children }) {
  return (
    <div className="legal-intro-banner">
      <p>{children}</p>
    </div>
  );
}

export function LegalIconList({ items, variant = "check" }) {
  const Icon = variant === "check" ? FaCheck : FaTimes;
  return (
    <ul className="legal-icon-list" role="list">
      {items.map((item, index) => (
        <li
          key={`${variant}-${index}`}
          className={`legal-icon-list__item legal-icon-list__item--${variant}`}
        >
          <span className="legal-icon-list__icon" aria-hidden="true">
            <Icon />
          </span>
          <span className="legal-icon-list__label">{item}</span>
        </li>
      ))}
    </ul>
  );
}

export function LegalCallout({ children, tone = "neutral" }) {
  return <div className={`legal-callout legal-callout--${tone}`}>{children}</div>;
}

export function LegalContactGrid({ items }) {
  return (
    <div className="legal-contact-grid">
      {items.map((item) => (
        <div key={item.label} className="legal-contact-item">
          <span className="legal-contact-item__label">{item.label}</span>
          <div className="legal-contact-item__value">{item.value}</div>
        </div>
      ))}
    </div>
  );
}
